<template>
  <FormModal
    v-if="data"
    title="Edit Language"
    method="PUT"
    :endpoint="`partners/${partner_id}/languages/${language_id}`"
    :data="data"
    v-bind="$attrs"
    @success="success"
  >
    <InputGroup label="Language" name="language_id">
      <Select v-model="data.language_id" endpoint="options/languages" />
    </InputGroup>

    <InputGroup
      label="Advisor Email Subject"
      name="advisor_email_subject"
      description="Available variables: %advisorName% %partnerName% %pageTitle% %pageUrl%"
    >
      <TextInput v-model="data.advisor_email_subject" />
    </InputGroup>

    <InputGroup
      label="Advisor Email Message"
      name="advisor_email_body"
      description="Available variables: %advisorName% %partnerName% %pageTitle% %pageUrl%"
    >
      <TextInput v-model="data.advisor_email_body" textarea />
    </InputGroup>

    <InputGroup label="CTA Label" name="cta_label">
      <TextInput v-model="data.cta_label" />
    </InputGroup>
  </FormModal>
</template>

<script>
export default {
  props: {
    partner_id: {
      type: Number,
      required: true
    },
    language_id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    data: {
      language_id: null,
      advisor_email_subject: null,
      advisor_email_body: null,
      cta_label: null
    }
  }),
  async mounted() {
    let response = await this.$api.get(`partners/${this.partner_id}/languages/${this.language_id}`)
    this.data = response.data.data
    this.data.language_id = response.data.data.language.id
    this.loading = false
  },
  methods: {
    success(result) {
      this.$notification.success(`Language successfully updated.`)
      this.$emit("close", result)
    }
  }
}
</script>
